<template>
    <div class='footer'>
        {{ $t('components.Footer.1') }}
    </div>
</template>

<script>
export default {
    name: 'Footer'
}
</script>

<style lang="scss" scoped>
@import "@/scss_variables/variables";
.footer {
    font-size: 1rem;
    text-align: center;
    padding: 2.5rem;
    background-color: $background-dark;
    color: $font-light;
}
</style>